export default "__VITE_ASSET__BK86MJL9__"